import { $axios } from "@/utils/http.js";
import prefix from "../base.js";

export default {
  // 发送手机验证码
  sendCode(data) {
    return $axios(`${prefix.user}/send_code`, data, "POST");
  },
  //绑定手机号码
  bindPhone(data) {
    return $axios(`${prefix.user}/bind_phone`, data, "POST");
  },
  //绑定guid获取角色列表
  getGuidInfo(data) {
    return $axios(`${prefix.user}/get_guid_info`, data, "GET");
  },
  //确认角色信息
  saveRoleInfo(data) {
    return $axios(`${prefix.user}/save_user`, data, "POST");
  },
  //保持收货地址
  saveAddress(data) {
    return $axios(`${prefix.user}/save_address`, data, "POST");
  },
  //获取个人中奖记录
  getPrizeRecord(data) {
    return $axios(`${prefix.user}/get_prize_record`, data, "GET");
  },
  //排行榜
  getPayKing(data) {
    return $axios(`${prefix.user}/get_pay_king`, data, "GET");
  }
};
